/* QuickBuy on Soft — the stand's toolbar control: a recessed track, the amount
   group (bolt, amount, gem) parted from P1–P3 by a short divider. In a column's
   head (data-size="head") it is the same control at the head's 28. */
/* fieldset + class: beats the .track atom whichever module loads last */
fieldset.quick {
  flex-shrink: 0;
  padding-left: 12px;
}

/* the amount field's focus: the track's rim lights, as a recessed field's does */
fieldset.quick:has(input:focus) {
  border-color: #474747;
}

.amount {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 18px;
  margin-right: 4px;
  padding-right: 10px;
  border-right: 1px solid var(--soft-menu-line);
  cursor: text;
}

/* ONE LINE for the bolt, the amount, the gem and P1–P3 (operator 2026-10-12:
   the amount "sits a little higher than the line" of the others). By
   construction, no pixel nudges (foundations.md, 2026-11-03): a P label's word
   is cut to its capitals (soft.fig) and centred in its segment. The amount is
   a form field, whose text no text-box reaches: it is set in the field face
   (soft.figField, on the input), whose line is its capitals, and it is as
   tall as the label, which a text field centres its line in: its figures sit
   on the middle of the bolt and the gem. */
.amount input {
  align-self: stretch;
  min-width: 54px;
  max-width: 104px;
  margin: 0;
  padding: 0;
  border: 0;
  outline: none;
  background: none;
  color: var(--soft-text);
  font-size: 14px;
  font-weight: var(--fw-num);
}

.amount input::placeholder {
  color: var(--soft-muted);
  font-weight: var(--fw-label);
  opacity: 1;
}

.bolt {
  flex-shrink: 0;
  color: var(--soft-text-2);
}

.amount svg:last-child {
  flex-shrink: 0;
}

/* P1–P3 lie in the track itself; the group is there for a narrow head, which
   folds it to the one button after it — the chosen preset, a press steps to
   the next. Wherever the three are shown that button is not. */
.presets {
  display: contents;
}

fieldset.quick .presetOne {
  display: none;
}

/* a P label, cut to its capitals, centred in its segment: on the middle of
   the bolt and the gem */
fieldset.quick .presets > button,
fieldset.quick .presetOne {
  align-items: center;
  justify-content: center;
}

fieldset.quick .presets > button {
  display: inline-flex;
}

/* ---- A column's head: 28 high like the head's other controls. It may give
   way when the head is full: the amount then scrolls inside its field. ---- */
fieldset.quick[data-size="head"] {
  flex-shrink: 1;
  /* never under what it holds: the amount's field at its floor and the preset
     beside it (the atom's min-width: 0 let the field slide under the preset) */
  min-width: min-content;
  height: 28px;
  padding-left: 8px;
}

fieldset.quick[data-size="head"] .amount {
  flex-shrink: 0;
  gap: 4px;
  height: 16px;
  margin-right: 3px;
  padding-right: 7px;
}

fieldset.quick[data-size="head"] .amount input {
  flex: 0 1 auto;
  min-width: 26px;
  max-width: 78px;
  font-size: 13px;
}

fieldset.quick[data-size="head"] .presets > button,
fieldset.quick[data-size="head"] .presetOne {
  height: 18px;
  padding: 0 5px;
  font-size: 12px;
}
